import request from "@/utils/service";

// 获取当前登陆的用户信息
export function getLoginUser(data) {
  return request({
    url: "/authorization/getLoginUser",
    method: "post",
    data
  });
}

// 获取账号列表
export function loadUserAuthority({ uuid, type, appCode } = {}) {
  return request({
    url: "/authorization/loadUserAuthority",
    method: "post",
    headers: { appCode, hideErrorMessage: true },
    data: { uuid, type }
  });
}

// 获取服务列表
export function getServerMap(data) {
  return request({
    url: "/platform-uc/portal/authority/app/list",
    method: "post",
    data
  });
}

// 退出登录
export function logout() {
  return request({
    url: "/platform-uc/public/authentication/logout",
    method: "post"
  });
}
// 获取密码策略
export function getPasswordStrategy() {
  return request({
    url: '/platform-uc/public/strategy/getPasswordStrategy',
    method: 'get'
  });
}
// 修改密码
export function resetPasswd(data) {
  return request({
    url: '/platform-uc/admin/user/resetPasswd',
    method: 'post',
    data
  });
}

export function getUnique() {
  return request({
    url: '/platform-uc/portal/company/getUnique',
    method: "get"
  });
}






// WEBPACK FOOTER //
// ./src/api/common/index.js